<template>
  <div class="flex flex-col m-2">
    <div class="flex flex-row items-center">
      <input type="checkbox" style="outline: none" v-bind="$attrs" :value="true"  @input="$emit('update:modelValue', $event.target.value)"/>
      <label class="ml-2 text-primary text-sm" v-html="label"></label>
      <slot name="suffix"></slot>
    </div>

  </div>
</template>
<script setup="props">
import { defineProps, defineComponent, reactive, watch } from "vue";

// disable attributte inheritence
defineComponent({
  inheritAttrs: false,
});

// define the component props
defineProps({
  label: String,
  checkboxName: String,
  checkboxLabel: String
});

// get the attrb on the component and bind them to the input element
// const attrs = useAttrs();
</script>
